import { FROM_APP_TOY_COMMAND } from '../constant';
export const updateFromAppToyCommand = data => ({type:FROM_APP_TOY_COMMAND, data})

